import { EventCategory } from '../EventCategory.model';
import eventCategories from '../eventCategories.json';
/**
 * Returns the event category based on the list of all supported IDs filtered by `listAllIdsSupported`.
 * If there is a EventIds that not are part of the supported categories, then it should add another category for them called `others`.
 * @param listAllIdsSupported - An array of strings representing all supported IDs of the workspace.
 *
 */
export function getEventCategory(
  listAllIdsSupported: string[]
): EventCategory[] {
  const allEventIds = eventCategories.reduce(
    (acc, category) => [...acc, ...category.eventIds],
    [] as string[]
  );
  const unsupportedEventIds = listAllIdsSupported.filter(
    (id) => !allEventIds.includes(id)
  );

  const othersCategory: EventCategory = {
    id: 'others',
    name_en: 'Others',
    eventIds: unsupportedEventIds,
  };
  return eventCategories
    .map((category) => {
      const filteredEventIds = category.eventIds.filter((eventId) =>
        listAllIdsSupported.includes(eventId)
      );
      return {
        ...category,
        eventIds: filteredEventIds,
      };
    })
    .filter((category) => category.eventIds.length > 0)
    .concat(unsupportedEventIds.length > 0 ? [othersCategory] : []);
}
